var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgImage = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.5,
  cx: 17,
  cy: 5,
  r: 3
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 22H5.861c-1.909 0-2.863 0-3.396-.399a2 2 0 0 1-.797-1.459c-.047-.663.47-1.466 1.502-3.072l3.138-4.883c.896-1.393 1.344-2.09 1.914-2.33a2 2 0 0 1 1.556 0c.57.24 1.018.937 1.914 2.33l2.808 4.369M18 22h.139c1.909 0 2.863 0 3.396-.399a2 2 0 0 0 .797-1.459c.047-.663-.47-1.466-1.502-3.072l-.638-.994c-.896-1.394-1.344-2.09-1.914-2.33a2 2 0 0 0-1.556 0c-.57.24-1.018.936-1.914 2.33l-.308.48M18 22l-3.5-5.444"
})));
export default SvgImage;